import React from 'react'
import { Box, Typography } from '@mui/material'
import { C, SX, TYPE } from '../../merchants/shared/tokens'

/** "Stage n of N" + step title + explainer, after D2C StageHeader. */
export default function PtlStageHeader({ index, total, title, explainer }) {
  return (
    <Box sx={{ ...SX.card, p: 2.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1.25 }}>
        <Box component='span' sx={{ ...SX.pill, color: '#fff', bgcolor: C.accent, textTransform: 'uppercase', letterSpacing: '0.05em', py: '4px', px: 1 }}>
          Stage {index + 1} of {total}
        </Box>
        <Typography component='h1' sx={{ ...TYPE.pageTitle, fontSize: 21 }}>{title}</Typography>
      </Box>
      {explainer && <Typography sx={{ ...TYPE.rowHelp, fontSize: 13.5, color: C.inkMuted, mt: 0.75, maxWidth: 880 }}>{explainer}</Typography>}
    </Box>
  )
}
